module.exports = __webpack_public_path__ + "static/media/thumbnail.104854d8.jpg";